/* Fashion CITY — 커스텀 상품 페이지: 총 금액 표시
   ─────────────────────────────────────────────────────────────
   쇼피파이 상품 페이지는 '개당 가격' 만 보여줍니다.
   그런데 우리 커스텀은 최소 6~12장씩 주문하는 거라,
   손님이 장바구니에 넣기 전까지 얼마인지 모릅니다. 그게 이탈 원인이 됩니다.

   그래서 장바구니 버튼 바로 위에 이렇게 띄웁니다:
       ESTIMATED TOTAL          $336.00
       24 pieces × $14.00 each · before shipping and tax

   수량은 옷이면 사이즈 칸 합계가 자동으로 들어옵니다 (fc-po.js 가 채웁니다).
   가공 방법(자수/풀컬러/펍)을 바꾸면 개당 가격도 같이 바뀝니다.

   ※ 개당 가격은 snippets/fc-po.liquid 의 fc-po-config 에서 넘어옵니다.
*/
(function () {
  'use strict';

  var cfgEl = document.getElementById('fc-po-config');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var CUR = CFG.currency || 'USD';

  function money(cents) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: CUR }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }
  function form() { return document.querySelector('form.js-product-form'); }
  function panel() { return document.querySelector('[data-fcpo]'); }

  function unitPrice() {
    var f = form();
    var i = f ? f.querySelector('[name="id"]') : null;
    var id = i ? String(i.value) : '';
    var list = CFG.variants || [];
    for (var k = 0; k < list.length; k++) {
      if (String(list[k].id) === id) return list[k].price || 0;
    }
    return list.length ? (list[0].price || 0) : 0;
  }
  function qty() {
    var f = form();
    var q = f ? f.querySelector('[name="quantity"]') : null;
    var n = q ? parseInt(q.value, 10) : 0;
    return (isNaN(n) || n < 0) ? 0 : n;
  }

  function ensure() {
    var p = panel();
    if (!p) return null;
    var el = p.querySelector('[data-fcpo-total]');
    if (el) return el;
    el = document.createElement('div');
    el.className = 'fcpo-total';
    el.setAttribute('data-fcpo-total', '');
    el.innerHTML =
      '<div class="fcpo-total__row">' +
        '<span>Estimated total</span>' +
        '<strong data-fcpo-total-sum>&mdash;</strong>' +
      '</div>' +
      '<p class="fcpo-total__sub" data-fcpo-total-sub></p>';
    p.appendChild(el);
    return el;
  }

  var lastKey = '';
  function render() {
    var el = ensure();
    if (!el) return;
    var n = qty();
    var unit = unitPrice();
    var key = n + '|' + unit;
    if (key === lastKey) return;
    lastKey = key;

    var sum = el.querySelector('[data-fcpo-total-sum]');
    var sub = el.querySelector('[data-fcpo-total-sub]');
    if (!n || !unit) {
      sum.innerHTML = '&mdash;';
      sub.textContent = 'Tell us how many you need and your total shows up here.';
      return;
    }
    sum.textContent = money(n * unit);
    sub.textContent = n + (n === 1 ? ' piece' : ' pieces') + ' × ' + money(unit) +
      ' each · before shipping and tax';
  }

  document.addEventListener('input', render, true);
  document.addEventListener('change', render, true);
  document.addEventListener('click', function () { setTimeout(render, 60); }, true);
  window.addEventListener('load', render);
  setInterval(render, 400);
  render();
})();